<template>
  <div
    class="tw-p-6"
    :class="{
      'two-drawer-layout__screen-height--after-secondary-subheader':
        !usingNewLayout,
    }"
  >
    <div
      class="
        tw-rounded-lg
        tw-h-full
        tw-max-w-condensed-content
        tw-mx-auto
        tw-flex
        tw-flex-row
        tw-w-full
      "
      :class="borderClasses"
    >
      <InboxEmpty v-if="empty && !loading" />
      <template v-else>
        <div
          class="
            tw-h-full
            tw-shrink-0
            tw-grow
            tw-rounded-l-lg
            tw-p-4
            tw-max-w-condensed-sidepane
            tw-w-condensed-sidepane
            tw-overflow-y-auto
            tw-bg-sf-neutral-subtle-1
          "
        >
          <FirmInboxLeftSidepane />
        </div>
        <div
          class="
            tw-h-full
            tw-shrink
            tw-grow
            tw-overflow-y-auto
            tw-bg-sf-snow-lighter
            tw-rounded-r-lg
          "
        >
          <FirmInboxCompanyPanel />
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import FirmInboxLeftSidepane from '@app/application/communication/screens/inbox/components/firm-inbox-left-sidepane.vue'
import FirmInboxCompanyPanel from '@app/application/communication/screens/inbox/components/firm-inbox-company-panel.vue'
import InboxEmpty from '@app/application/communication/screens/inbox/components/inbox-empty.vue'
import { computed, watchEffect } from 'vue'
import { useStore } from 'vuex'
import { useInboxFiltersStore } from '@app/application/communication/screens/inbox/store/inbox-filters'
import { isUsingNewLayout } from '@app/adapters/silverfin'
import { UNTAGGED_FILTER } from '@app/application/communication/screens/inbox/store/constants'

const store = useStore()

const companies = computed(() =>
  Object.keys(store.state.notifications.companies)
)
const empty = computed(() => companies.value.length === 0)
const loading = computed(() => store.getters.loadingCompanies)

const borderClasses = computed(() => {
  return empty.value && !loading.value
    ? []
    : ['tw-border', 'tw-border-solid', 'tw-border-sf-neutral-lighter-2']
})

const inboxFiltersStore = useInboxFiltersStore()
const usingNewLayout = isUsingNewLayout()

watchEffect(() => {
  const [tagIds, untagged] = (() => {
    if (inboxFiltersStore.tags?.includes(UNTAGGED_FILTER)) {
      return [undefined, true]
    } else {
      return [inboxFiltersStore.tags, undefined]
    }
  })()

  const filters = {
    noteType: inboxFiltersStore.noteType,
    tagIds,
    untagged,
    search: inboxFiltersStore.searchTerm,
  }

  if (!inboxFiltersStore.receivedInitialValues) return

  store.dispatch('fetchCompanies', filters)
})
</script>
